import { Component, OnInit, OnDestroy, Input, Output, EventEmitter } from '@angular/core';
// ionic
import { ModalController } from '@ionic/angular';
import { Events } from '../../helpers/events';

// other libraries
import { TranslateService } from "@ngx-translate/core";

// rxjs
import { Subject } from "rxjs";
import { takeUntil } from "rxjs/operators";

// services
import { EventService } from "../../services/event.service";
import { PlatformService } from "../../services/platform.service";
import { UserService } from "../../services/user.service";

// models
import { Event } from "../../models/event";
import { Keyword } from "../../models/keyword";
import { User } from "../../models/user";
import { Marketplace } from "../../models/marketplace";

@Component({
    selector: 'marketplace-info',
    templateUrl: './marketplace-info.component.html',
    styleUrls: ['./marketplace-info.component.scss'],
})
export class MarketplaceInfoComponent implements OnInit, OnDestroy {

    @Input() marketplace: Marketplace;

    /**
     * unsubscribe subject
     *
     * @type {Subject<void>}
     */
    private ngUnsubscribe: Subject<void> = new Subject<void>();

    /**
     * selected language
     *
     * @type string
     */
    public userLang: string;


    /**
     * show loading
     *
     * @type {boolean}
     */
    public loading: boolean = true;

    constructor(
        public plt: PlatformService,
        public appEvents: Events,
        public eventService: EventService,
        public userService: UserService,
        public modalController: ModalController,
        public translate: TranslateService,
    ) {

        // user language
        this.userLang = this.translate.currentLang;
    }

    ngOnInit() {
    }

    /**
     * close modal window
     *
     */
    public backClicked() {
        this.modalController.dismiss({
            action: 'close'
        });
    }

    /**
     * on destroy
     *
     * @return void
     */
    ngOnDestroy() {
        this.ngUnsubscribe.next();
        this.ngUnsubscribe.complete();
    }
}
